// extracted by mini-css-extract-plugin
export default {"drawer":"MobileFiltersDrawer_drawer__vPqGY","section":"MobileFiltersDrawer_section__VF00n","footer":"MobileFiltersDrawer_footer__ucN8t"};